export default {"src":"/_next/static/media/loadingdark.c4f39e1d.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};